import React, { Component } from "react";
import {
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Button
} from "reactstrap";


class ConfirmationModal extends Component{
    constructor(props){
        super(props);
    }

    render(){
        return (
            <Modal isOpen={this.props.isOpen} toggle={this.props.toggle}>
                {
                    this.props.title ?
                        <ModalHeader toggle={this.props.toggle}>{this.props.title}</ModalHeader>
                        : ""
                }
                <ModalBody>
                    {this.props.content}
                </ModalBody>
                <ModalFooter className="center">
                    <Button className="text-uppercase" size="" color="secondary" onClick={this.props.refuse}>Non</Button>{' '}
                    <Button className="text-uppercase" size="" color="primary" onClick={this.props.validate}>Oui</Button>
                </ModalFooter>
            </Modal>
        );
    }
}

ConfirmationModal.defaultProps = {
    title: false,
    content: "Êtes-vous sur de vouloir effectuer cette action ?",
    isOpen: false,
    toggle: () => {},
    validate: () => {},
    refuse: () => {}
};

export default ConfirmationModal;


// WEBPACK FOOTER //
// ./src/components/ConfirmationModal.js